import { Component, inject } from '@angular/core';

import { Router } from '@angular/router';
import { AuthenticationClientService } from '../../../../../core/api/api/authentication-client.service';
import { firstValueFrom } from 'rxjs';
import { TranslocoDirective } from '@jsverse/transloco';
import { LegalLinksContainerComponent } from '../../../../../shared/components/legal-links-container/legal-links-container.component';
import { PasswordResetFormComponent } from '../../../../../shared/components/password-reset-form/password-reset-form.component';

@Component({
  selector: 'app-request-password-reset',
  imports: [TranslocoDirective, LegalLinksContainerComponent, PasswordResetFormComponent],
  templateUrl: './request-password-reset.component.html',
  styleUrl: './request-password-reset.component.css',
  standalone: true
})
export class RequestPasswordResetComponent {
  private readonly authService = inject(AuthenticationClientService);
  private readonly router = inject(Router);
  public isLoading = false;

  public async onFormSubmit(email: string): Promise<void> {
    this.isLoading = true;

    try {
      await firstValueFrom(this.authService.requestPasswordReset(email));
      console.log('Password reset email sent successfully');
      this.router.navigate(['/auth/forgot-password/mail-sent'], {
        queryParams: { email }
      });
    } catch {
      // See Story TX-93. We don't display any error message. So the User will be always redirected to the
      // mail-sent view
      this.router.navigate(['/auth/forgot-password/mail-sent'], {
        queryParams: { email }
      });
    } finally {
      this.isLoading = false;
    }
  }
}
